import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LoggingModule } from "../logging/logging.module";
import { MaterialModule } from "../material/material.module";
import { AuthDialogComponent } from "./auth-dialog/auth-dialog.component";
import { EffectsModule } from "@ngrx/effects";
import { AuthEffects } from "./state/auth/auth.effects";
import { StoreModule } from "@ngrx/store";
import { authFeatureKey, authReducer } from "./state/auth/auth.reducer";
import { FormsModule } from "@angular/forms";
import { PadlockModule } from "../padlock/padlock.module";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthInterceptor } from "./auth.interceptor";
import { SharedModule } from "../shared/shared.module";

import {
  IPublicClientApplication,
  PublicClientApplication,
  BrowserCacheLocation,
  LogLevel,
} from "@azure/msal-browser";
import {
  MsalService,
  MSAL_INSTANCE,
  MsalBroadcastService,
} from "@azure/msal-angular";
import { b2cPolicies, clientId, redirectUri } from "./b2c-config";
import { environment } from "src/environments/environment";

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId,
      authority: b2cPolicies.authorities.signUpSignIn.authority,
      redirectUri,
      knownAuthorities: [b2cPolicies.authorityDomain],
    },
    cache: { cacheLocation: BrowserCacheLocation.LocalStorage },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: !environment.production ? LogLevel.Info : LogLevel.Error,
        piiLoggingEnabled: false,
      },
    },
  });
}

@NgModule({
  declarations: [AuthDialogComponent],
  imports: [
    CommonModule,
    LoggingModule,
    FormsModule,
    MaterialModule,
    PadlockModule,
    SharedModule,
    StoreModule.forFeature(authFeatureKey, authReducer),
    EffectsModule.forFeature([AuthEffects]),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    MsalService,
    MsalBroadcastService,
  ],
})
export class AuthModule {}
